import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/inputReadyProducts';
import { get, post } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* inputReadyProducts({ payload }) {
  try {
    const response = yield call(get, `/operation/ready/get/?operationNumId=${payload}`);
    yield put(action.inputReadyProductsSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.inputReadyProductsFail());
  }
}

export function* updateReadyProducts({ payload }) {
  try {
    const response = yield call(post, '/operation/ready/update', payload);
    yield put(action.updateReadyProductsSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.updateReadyProductsFail());
  }
}
